import "./login.css.js";
const n = {
  brand: "pf-v6-c-brand",
  button: "pf-v6-c-button",
  list: "pf-v6-c-list",
  login: "pf-v6-c-login",
  loginContainer: "pf-v6-c-login__container",
  loginFooter: "pf-v6-c-login__footer",
  loginHeader: "pf-v6-c-login__header",
  loginMain: "pf-v6-c-login__main",
  loginMainBody: "pf-v6-c-login__main-body",
  loginMainFooter: "pf-v6-c-login__main-footer",
  loginMainFooterBand: "pf-v6-c-login__main-footer-band",
  loginMainFooterLinks: "pf-v6-c-login__main-footer-links",
  loginMainFooterLinksItem: "pf-v6-c-login__main-footer-links-item",
  loginMainHeader: "pf-v6-c-login__main-header",
  loginMainHeaderDesc: "pf-v6-c-login__main-header-desc",
  loginMainHeaderUtilities: "pf-v6-c-login__main-header-utilities",
  menuToggle: "pf-v6-c-menu-toggle",
  title: "pf-v6-c-title"
};
export {
  n as default
};
